<h1>
    Delete Application?
</h1>
<p>
    Do you really want to delete application «{{application.name}}»?<br/>
    All tasks created from this application will also be deleted.
</p>
<div class="buttons">
    <button class="default" (click)="delete()">
        Delete
    </button>
    <button class="outline" (click)="cancel()">
        Cancel
    </button>
</div>
<ui-loading *ngIf="isLoading"></ui-loading>
